<template>
    <div class="mx-auto container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg != null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="box">
            <v-toolbar dense class="toolbar" flat color="white">
                <v-toolbar-title>Room Utilization Report</v-toolbar-title>
                <v-divider class="mx-4" inset vertical></v-divider>
                <v-spacer></v-spacer>
            </v-toolbar>

            <v-row justify="center" dense>
                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error">*</v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="exam_plan"
                        item-value="id"
                        :items="exam_plan_list"
                        item-text="exam_name"
                        label="Exam Plan"
                        outlined
                        persistent-hint
                        hint="Please Select Exam Plan"
                        @change="getExamPlanData()"
                    />
                </v-col>

                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error"></v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="session_number"
                        item-value="session_id"
                        :items="session_list"
                        item-text="session_number"
                        label="Session No"
                        outlined
                        persistent-hint
                        hint="Please Select Session No"
                    />
                </v-col>

                <v-col cols="12" sm="3" md="3">
                    <v-icon color="error"></v-icon>
                    <v-autocomplete
                        color="#0F2027"
                        dense
                        rounded
                        required
                        v-model="room"
                        item-value="room_id"
                        :items="room_list"
                        item-text="room_no"
                        label="Room"
                        outlined
                        persistent-hint
                        hint="Please Select Room"
                    />
                </v-col>
            </v-row>

            <v-row justify="center">
                <v-col cols="auto" class="pt-0 mb-5 ml-9">
                    <v-btn color="primary" @click="fetchRoomUtilizationReport()" small>
                        Fetch
                    </v-btn>
                </v-col>
            </v-row>
            <div v-if="reportFetched">
                 <v-row dense align="center">
                        <v-col cols="auto" class="pa-0">
                            <v-btn rounded color="success" outlined :loading="loader" @click="downloadFile" small
                                class="mt-2 ml-2">
                                <v-icon left color="success">mdi-export</v-icon>
                                Export EXCEL
                            </v-btn>
                        </v-col>

                        <v-col cols="auto" class="pa-0 pl-1">
                            <v-btn rounded color="error" outlined @click="printPDF" small class="mt-2">
                                <v-icon left color="error">mdi-file-pdf-box</v-icon>
                                Export PDF
                            </v-btn>
                        </v-col>
                        <v-spacer></v-spacer>

                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                        clearable
                        class="search-field"
                    ></v-text-field>

                </v-row>
                <v-row >
                        <v-col cols="12" sm="" md="2" align="center">
                            <img :src="org_basic_data.school_logo" class="print-logo" width="50%" alt="logo" />
                        </v-col>
                        <v-col cols="12" sm="8" md="8" align="center">
                        <h2 v-if="org_basic_data.trust_name" class="trust_name" >
                           {{ org_basic_data.trust_name }}
                        </h2>
                        <h2 style="text-transform: uppercase;" v-if="org_basic_data.school_name" class="school_name">
                            {{ org_basic_data.school_name }}</h2>
                            <!-- <h4 style="text-transform: uppercase;" class="scheme_name"> {{ ass_Scheme }} - {{ academicyear }} </h4> -->
                        <h3 class="report_name">Door Display Report</h3>
                               
                        </v-col>
                        <v-col cols="12" sm="2" md="2" align="center">
                            <img :src="org_basic_data.trust_logo" class="print-logo" width="50%" alt="logo" />
                        </v-col>
                    </v-row>
                    <v-simple-table  fixed-header height="500px" dense class="elevation-1 scroll table-data">
                
                        <thead>
                                <tr>
                                    <th class="sticky-header"><center>S. No.</center></th>
                                    <th class="sticky-header"><center>Room No</center></th>
                                    <th class="sticky-header"><center>Benches</center></th>
                                    <th class="sticky-header"><center>Capacity Per Bench</center></th>
                                    <th class="sticky-header"><center>Total Seats</center></th>
                                    <th class="sticky-header"><center>Allotted Seats</center></th>
                                    <th class="sticky-header"><center>Available Seats</center></th>
                                    <th class="sticky-header"><center>Supervisor</center></th>
                                    <th class="sticky-header"><center>Academic Year</center></th>
                                    <th class="sticky-header"><center>Semester</center></th>
                                    <th class="sticky-header"><center>Exam Plan</center></th>
                                </tr>
                        </thead>
                        <tbody style="overflow-y: scroll; border: 1px solid #ccc;">
                                <tr v-for="(s, index) in filterRoomUtilizationReport" :key="s.cid || index">
                                    <td>{{ index + 1 }}</td>
                                    <td>{{ s.room_no }}</td>
                                    <td>{{ s.benches }}</td>
                                    <td>{{ s.capacity_per_bench }}</td>
                                    <td>{{ s.total_seats }}</td>
                                    <td>{{ s.allotted_seats }}</td>
                                    <td>{{ s.available_seats }}</td>
                                    <td>{{ s.supervisor }}</td>
                                    <td>{{ s.academic_year }}</td>
                                    <td>{{ s.semester }}</td>
                                    <td>{{ s.exam_name }}</td>
                            </tr>
                            <tr v-if="room_utilization_report.length > 0">
                        <td colspan="2">
                            <strong>TOTAL</strong>
                        </td>
                        <td>
                            <strong>{{ totalCounts ? totalCounts.total_benches : 0 }}</strong>
                        </td>
                        <td></td>
                        <td>
                            <strong>{{ totalCounts ? totalCounts.total_seats : 0 }}</strong>
                        </td>
                        <td>
                            <strong>{{ totalCounts ? totalCounts.total_allotted_seats : 0 }}</strong>
                        </td>
                        <td>
                            <strong>{{ totalCounts ? totalCounts.total_available_seats : 0 }}</strong>
                        </td>
                        <td colspan="4"></td>
                       </tr>
                    </tbody>


            </v-simple-table>

            </div>

            <v-overlay :value="overlay">
                <v-progress-circular indeterminate size="64"></v-progress-circular>
            </v-overlay>
        </v-card>

        <div id="pdf-report" class="pdf-report">
            <v-row>
                    <v-col cols="12" sm="2" md="2" align="center">
                            <img :src="org_basic_data.school_logo" class="print-logo" width="50%" alt="logo" />
                    </v-col>
                    <v-col cols="12" sm="8" md="8" align="center">
                         <h2 v-if="org_basic_data.trust_name" class="trust_name" >
                             {{ org_basic_data.trust_name }}
                         </h2>
                        <h2 style="text-transform: uppercase;" v-if="org_basic_data.school_name" class="school_name">
                            {{ org_basic_data.school_name }}</h2>
                          <!-- <h4 style="text-transform: uppercase;" class="scheme_name"> {{ ass_Scheme }} - {{ academicyear }} </h4> -->
                        <h2 class="report_name">Room Utilization Report</h2>
                               
                      </v-col>
                            <v-col cols="12" sm="2" md="2" align="center">
                                <img :src="org_basic_data.trust_logo" class="print-logo" width="50%" alt="logo" />
                            </v-col>
                        </v-row>

           

                    <table>
                        <thead>
                            <tr>
                                <th>S.No</th>
                                <th>Room No</th>
                                <th>Benches</th>
                                <th>Capacity Per Bench</th>
                                <th>Total Seats</th>
                                <th>Allotted Seats</th>
                                <th>Available Seats</th>
                                <th>Supervisor</th>
                                <th>Academic Year</th>
                                <th>Semester</th>
                                <th>Exam Plan</th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr v-for="(item, index) in room_utilization_report" :key="index">
                                <td>{{ index + 1 }}</td>
                                <td>{{ item.room_no }}</td>
                                <td>{{ item.benches }}</td>
                                <td>{{ item.capacity_per_bench }}</td>
                                <td>{{ item.total_seats }}</td>
                                <td>{{ item.allotted_seats }}</td>
                                <td>{{ item.available_seats }}</td>
                                <td>{{ item.supervisor }}</td>
                                <td>{{ item.academic_year }}</td>
                                <td>{{ item.semester }}</td>
                                <td>{{ item.exam_name }}</td>
                            </tr>

                            <tr v-if="room_utilization_report.length > 0">
                                <td colspan="2">
                                    <strong>TOTAL</strong>
                                </td>
                                <td>
                                    <strong>{{ totalCounts ? totalCounts.total_benches : 0 }}</strong>
                                </td>
                                <td></td>
                                <td>
                                    <strong>{{ totalCounts ? totalCounts.total_seats : 0 }}</strong>
                                </td>
                                <td>
                                    <strong>{{ totalCounts ? totalCounts.total_allotted_seats : 0 }}</strong>
                                </td>
                                <td>
                                    <strong>{{ totalCounts ? totalCounts.total_available_seats : 0 }}</strong>
                                </td>
                                <td colspan="4"></td>
                            </tr>
                        </tbody>
                    </table>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import * as XLSX from "xlsx";

export default {
    data: () => ({
        valid: false,
        overlay: false,
        loader: false,
        snackbar_msg: "",
        color: "",
        snackbar: false,
        search: "",
        dialog: false,
        exam_plan: "",
        standard: "",
        subject: "",
        room: "",
        org_basic_data: [],
        reportFetched: false,
        session_number: "",
        supervisor: "",
        present: false,
        absent: false,
        headers: [
            { text: "S.No", align: "left", sortable: false, value: "srno" },
            { text: "Room No", align: "left", sortable: false, value: "room_no" },
            { text: "Benches", align: "left", sortable: true, value: "benches" },
            { text: "Capacity Per Bench", align: "left", sortable: true, value: "capacity_per_bench" },
            { text: "Total Seats", align: "left", sortable: true, value: "total_seats" },
            { text: "Allotted Seats", align: "left", sortable: true, value: "allotted_seats" },
            { text: "Available Seats", align: "left", sortable: true, value: "available_seats" },
            { text: "Supervisor", align: "left", sortable: true, value: "supervisor" },
            { text: "Academic Year", align: "left", sortable: true, value: "academic_year" },
            { text: "Semester", align: "left", sortable: true, value: "semester" },
            { text: "Exam Plan", align: "left", sortable: true, value: "exam_name" }
        ],
        exam_plan_list: [],
        room_list: [],
        student_list: [],
        session_list: [],
        room_utilization_report: [],
        editedIndex: -1,
        totalCounts: null
    }),

    watch: {
        dialog(val) {
            val || this.close();
        },
        overlay(val) {
            val = () => {
                this.overlay = false;
            };
        }
    },

    mounted() {
        this.onLoad();
    },
    computed: {
        filterRoomUtilizationReport() {
            const data = this.room_utilization_report || [];
            const query = (this.search || "").toLowerCase().trim();

            if (!query) {
            return data;
            }

            return data.filter(item =>
            Object.values(item).some(value =>
                String(value == null ? "" : value)
                .toLowerCase()
                .includes(query)
            )
            );
        }
    },

    methods: {
        onLoad() {
            this.overlay = true;
            axios
                .post("/SeatingArrangement/getData")
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.exam_plan_list = res.data.exam_plan_list;

                        const savedPlan = localStorage.getItem("exam_plan");

                        if (savedPlan) {
                            this.exam_plan = Number(savedPlan);
                            this.getExamPlanData(this.exam_plan);
                        }
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        getExamPlanData() {
            const data = {
                exam_plan: this.exam_plan
            };

            this.overlay = true;

            axios
                .post("/SeatingArrangement/getDataOnExamPlan", data)
                .then((res) => {
                    if (res.data.msg == "200") {
                        this.overlay = false;
                        this.session_list = res.data.session_list;
                        this.room_list = res.data.room_list;

                        if (this.session_list.length > 0) {
                            this.session_list = [
                                {
                                    id: "All",
                                    session_number: "All"
                                }
                            ].concat(res.data.session_list || []);
                        }

                        if (this.room_list.length > 0) {
                            this.room_list = [
                                {
                                    id: "All",
                                    room_no: "All"
                                }
                            ].concat(res.data.room_list || []);
                        }
                    }
                })
                .catch(() => {
                    this.showSnackbar("#b71c1c", "Something went wrong...");
                })
                .finally(() => {
                    this.overlay = false;
                });
        },

        // fetchRoomUtilizationReport() {
        //     this.overlay = true;

        //     const data = {
        //         exam_plan: this.exam_plan,
        //         session_number: this.session_number,
        //         room: this.room
        //     };

        //     axios
        //         .post("/SeatingArrangement/fetchRoomUtilizationReport", data)
        //         .then((res) => {
        //             if (res.data.msg == "200") {
        //                 this.overlay = false;
        //                 this.room_utilization_report = res.data.room_utilization_report;
        //                 this.totalCounts = res.data.summary || null;
        //             } else {
        //                 window.console.log(res.data.msg);
        //             }
        //         })
        //         .catch((error) => {
        //             this.showSnackbar("#b71c1c", "Something went wrong...");
        //             window.console.log(error);
        //         })
        //         .finally(() => {
        //             this.overlay = false;
        //         });
        // },
        fetchRoomUtilizationReport() {
        this.overlay = true;
        this.reportFetched = false;
        this.room_utilization_report = [];
        this.org_basic_data = [];
        this.totalCounts = null;

        const data = {
            exam_plan: this.exam_plan,
            session_number: this.session_number,
            room: this.room
        };

        axios
            .post("/SeatingArrangement/fetchRoomUtilizationReport", data)
            .then((res) => {
            console.log("Room Utilization Response:", res.data);

            if (String(res.data.msg) === "200") {
                this.room_utilization_report =
                res.data.room_utilization_report || [];

                this.org_basic_data = res.data.org_basic_data || [];
                this.totalCounts = res.data.summary || null;

                if (this.room_utilization_report.length > 0) {
                this.reportFetched = true;
                } else {
                this.showSnackbar(
                    "#b71c1c",
                    "No room utilization details found."
                );
                }
            } else {
                this.showSnackbar(
                "#b71c1c",
                "No room utilization details found."
                );
            }
            })
            .catch((error) => {
            console.error("Room Utilization Error:", error);
            this.showSnackbar("#b71c1c", "Something went wrong...");
            })
            .finally(() => {
            this.overlay = false;
            });
        },
        showSnackbar(clr, msg) {
            this.snackbar = true;
            this.color = clr;
            this.snackbar_msg = msg;
        },

        close() {
            this.dialog = false;
            this.initializeErrorMsgFalse();

            setTimeout(() => {
                this.editedItem = Object.assign({}, this.defaultItem);
                this.editedIndex = -1;
            }, 300);
        },

        downloadFile() {
            this.loader = true;

            const excelData = this.room_utilization_report.map((item, index) => ({
                "S.No": index + 1,
                "Room No": item.room_no,
                "Benches": item.benches,
                "Capacity Per Bench": item.capacity_per_bench,
                "Total Seats": item.total_seats,
                "Alloted Seats": item.allotted_seats,
                "Available Seats": item.available_seats,
                "Supervisor": item.supervisor,
                "Academic Year": item.academic_year,
                "Semester": item.semester,
                "Exam Plan": item.exam_name
            }));

            var totalBenches =
                this.totalCounts &&
                this.totalCounts.total_benches !== undefined &&
                this.totalCounts.total_benches !== null
                    ? this.totalCounts.total_benches
                    : this.room_utilization_report.reduce(function(acc, curr) {
                        return acc + (Number(curr.benches) || 0);
                    }, 0);

            var totalSeats =
                this.totalCounts &&
                this.totalCounts.total_seats !== undefined &&
                this.totalCounts.total_seats !== null
                    ? this.totalCounts.total_seats
                    : this.room_utilization_report.reduce(function(acc, curr) {
                        return acc + (Number(curr.total_seats) || 0);
                    }, 0);

            var totalAllotted =
                this.totalCounts &&
                this.totalCounts.total_allotted_seats !== undefined &&
                this.totalCounts.total_allotted_seats !== null
                    ? this.totalCounts.total_allotted_seats
                    : this.room_utilization_report.reduce(function(acc, curr) {
                        return acc + (Number(curr.allotted_seats) || 0);
                    }, 0);

            var totalAvailable =
                this.totalCounts &&
                this.totalCounts.total_available_seats !== undefined &&
                this.totalCounts.total_available_seats !== null
                    ? this.totalCounts.total_available_seats
                    : this.room_utilization_report.reduce(function(acc, curr) {
                        return acc + (Number(curr.available_seats) || 0);
                    }, 0);

            if (excelData.length > 0) {
                excelData.push({
                    "S.No": "",
                    "Room No": "TOTAL",
                    "Benches": totalBenches,
                    "Capacity Per Bench": "",
                    "Total Seats": totalSeats,
                    "Alloted Seats": totalAllotted,
                    "Available Seats": totalAvailable,
                    "Supervisor": "",
                    "Academic Year": "",
                    "Semester": "",
                    "Exam Plan": ""
                });
            }

            const worksheet = XLSX.utils.json_to_sheet(excelData);
            const workbook = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(
                workbook,
                worksheet,
                "Room Utilization Report"
            );

            XLSX.writeFile(
                workbook,
                "RoomUtilizationReport.xlsx"
            );

            this.loader = false;
        },

        printPDF() {
            if (!this.room_utilization_report || this.room_utilization_report.length === 0) {
                this.showSnackbar("#b71c1c", "No data available for PDF export.");
                return;
            }

            window.print();
        }
    }
};
</script>

<style>
#pdf-report {
    display: none;
}

@media print {
    @page {
        size: A4 landscape;
        /* margin: 8mm; */
        margin-left: -40px;
    }

    html,
    body,
    #app,
    .v-application,
    .v-application--wrap,
    .container {
        width: 100% !important;
        height: auto !important;
        min-height: 0 !important;
        max-height: none !important;
        margin: 0 !important;
        padding: 0 !important;
        overflow: visible !important;
        background: #ffffff !important;
    }

    body {
        -webkit-print-color-adjust: exact !important;
        print-color-adjust: exact !important;
    }

    .v-card,
    .v-toolbar,
    .v-data-table,
    .v-overlay,
    .v-snack,
    .v-footer {
        display: none !important;
    }

    #pdf-report {
        display: block !important;
        visibility: visible !important;
        width: 99% !important;
        max-width: 99% !important;
        margin: 0 auto !important;
        padding: 0 !important;
        position: static !important;
        box-sizing: border-box !important;
    }

    #pdf-report * {
        visibility: visible !important;
        box-sizing: border-box !important;
    }

   #pdf-report h2 {
    width: 100% !important;
    text-align: center !important;
    font-size: 18px !important; 
    font-weight: bold !important;
    margin: 0 0 8px 0 !important;
    padding: 0 !important;
    line-height: 1.3 !important;
}

    #pdf-report table {
        width: 99% !important;
        max-width: 99% !important;
        margin: 0 auto !important;
        padding: 0 !important;
        border-collapse: collapse !important;
        border-spacing: 0 !important;
        border: 1px solid #000 !important;
        font-size: 7px !important;
    }

   #pdf-report th,
   #pdf-report td {
    border: 1px solid #000 !important;
    padding: 3px !important;
    text-align: center !important;
    vertical-align: middle !important;
    line-height: 1.2 !important;
    word-break: normal !important;
    overflow-wrap: break-word !important;
    font-size: 12px !important;
}


   #pdf-report th {
    font-size: 14px !important; 
    font-weight: bold !important;
    background-color: #eeeeee !important;
    color: #000000 !important;
    -webkit-print-color-adjust: exact !important;
    print-color-adjust: exact !important;
}

    #pdf-report thead {
        display: table-header-group !important;
    }

    #pdf-report tbody {
        display: table-row-group !important;
    }

    #pdf-report tr {
        page-break-inside: avoid !important;
        break-inside: avoid !important;
    }

    #pdf-report td strong {
        font-weight: bold !important;
    }
}
</style>